import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Atlas uses custom font-size tokens (text-body, text-caption, etc.) and custom
// text-color tokens (text-text-primary, text-accent-500, etc.). Without this
// configuration, tailwind-merge can't distinguish them from each other and
// silently drops color utilities when a size utility follows in the same string.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            // Added 2026-09-17 with the dense-surface steps. Registering a new font-size token
            // here is NOT optional: without it tailwind-merge cannot tell `text-data` from
            // `text-text-secondary`, treats them as one group, and silently drops whichever comes
            // first — so a size class written in a `cn()` beside a colour simply vanishes. It
            // cost an hour tonight: the Rental lead kept rendering at the inherited 14px with
            // `text-data` nowhere in the DOM's class list.
            'data',
            'micro',
            'caption',
            'label',
            'body',
            'body-lg',
            'h1',
            'h2',
            'h3',
            'subline',
            'display',
            'badge',
          ],
        },
      ],
      'text-color': [
        {
          text: [
            'text-primary',
            'text-secondary',
            'text-muted',
            'text-inverse',
          ],
        },
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
